module.exports = __webpack_public_path__ + "img/drawer_welcome.9c937cf4.svg";